<template>
  <div class="admin-page">
    <div class="admin-layout">
      <!-- Left Sidebar -->
      <div :class="['admin-sidebar', { 'collapsed': isCollapsed }]">
        <!-- Toggle Button -->
        <div class="toggle-button" @click="toggleSidebar">
          <span v-if="isCollapsed">&#9658;</span>
          <span v-else>&#9668;</span>
        </div>

        <!-- Menu Items -->
        <ul>
          <!-- <li v-tooltip="isCollapsed ? 'Users' : ''">
            <router-link to="/admin/manage-users" exact-active-class="active-link">
              <i class="icon fas fa-user"></i>
              <span v-if="!isCollapsed">Users</span>
            </router-link>
          </li>
          <li v-tooltip="isCollapsed ? 'Payments' : ''">
            <router-link to="/admin/manage-payments" exact-active-class="active-link">
              <i class="icon fas fa-credit-card"></i>
              <span v-if="!isCollapsed">Payments</span>
            </router-link>
          </li> -->
          <li v-tooltip="isCollapsed ? 'Chatbots' : ''">
            <router-link to="/admin/manage-chatbots" exact-active-class="active-link">
              <i class="icon fas fa-robot"></i>
              <span v-if="!isCollapsed">Chatbots</span>
            </router-link>
          </li>
          <li v-tooltip="isCollapsed ? 'Knowledge Documents' : ''">
            <router-link to="/admin/manage-knowledge-documents" exact-active-class="active-link">
              <i class="icon fas fa-book"></i>
              <span v-if="!isCollapsed">Knowledge Documents</span>
            </router-link>
          </li>
          <li v-tooltip="isCollapsed ? 'Management' : ''">
            <router-link to="/admin" exact-active-class="active-link">
              <i class="icon fas fa-chart-bar"></i>
              <span v-if="!isCollapsed">Management</span>
            </router-link>
          </li>
          <!-- <li v-tooltip="isCollapsed ? 'Chat Messages' : ''">
            <router-link to="/admin/chat-messages" exact-active-class="active-link">
              <i class="icon fas fa-comments"></i>
              <span v-if="!isCollapsed">Chat Messages</span>
            </router-link>
          </li> -->
        </ul>
      </div>

      <!-- Right Content -->
      <div class="admin-content">
        <router-view></router-view>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "AdminPage",
  data() {
    return {
      isCollapsed: false,
    };
  },
  methods: {
    toggleSidebar() {
      this.isCollapsed = !this.isCollapsed;
    },
  },
  created() {
    if (!localStorage.getItem('isAuthenticated')) {
      this.$router.push('/login');
    }
  },
};
</script>

<style scoped>
.admin-page {
  min-height: 100vh;
  display: flex;
  background: linear-gradient(180deg, rgba(17, 24, 39, 0.85) 0%, rgba(0, 0, 0, 0.95) 100%);
}

.admin-layout {
  margin-top: 80px;
  display: grid;
  grid-template-columns: 260px 1fr;
  gap: 20px;
  width: 100%;
  padding: 0 20px 40px;
}

.admin-sidebar {
  background: linear-gradient(180deg, rgba(17, 24, 39, 0.9) 0%, rgba(10, 12, 20, 0.9) 100%);
  border: 1px solid var(--border-color);
  border-radius: var(--radius-2xl);
  box-shadow: var(--shadow-card);
  padding: 16px;
  transition: width 0.3s ease, padding 0.3s ease;
  position: sticky;
  top: 90px;
  height: fit-content;
}

.admin-sidebar.collapsed {
  width: 72px;
  padding: 12px;
}

.toggle-button {
  cursor: pointer;
  text-align: center;
  color: var(--text-primary);
  margin-bottom: 16px;
  padding: 8px;
  border-radius: var(--radius-xl);
  background: var(--bg-glass);
  border: 1px solid var(--border-color);
}

.admin-sidebar ul {
  list-style: none;
  padding: 0;
  margin: 0;
  display: grid;
  gap: 6px;
}

.admin-sidebar ul li a {
  text-decoration: none;
  color: var(--text-secondary);
  font-weight: 600;
  padding: 10px 12px;
  display: flex;
  align-items: center;
  gap: 10px;
  border-radius: var(--radius-xl);
  transition: all 0.2s ease;
}

.admin-sidebar ul li a .icon {
  width: 20px;
  text-align: center;
}

.admin-sidebar ul li a.active-link {
  background: linear-gradient(90deg, var(--accent-orange) 0%, var(--accent-orange-hover) 100%);
  color: #0b0f1a;
  box-shadow: var(--shadow-cta);
}

.admin-sidebar ul li a:hover {
  background: rgba(255, 255, 255, 0.08);
  color: var(--text-primary);
}

.admin-content {
  width: 100%;
  background: var(--bg-glass);
  border: 1px solid var(--border-color);
  border-radius: var(--radius-2xl);
  box-shadow: var(--shadow-card);
  padding: 24px;
  min-height: 70vh;
  backdrop-filter: blur(10px);
  color: var(--text-primary);
}

@media (max-width: 900px) {
  .admin-layout {
    grid-template-columns: 1fr;
  }

  .admin-sidebar {
    position: relative;
    top: 0;
  }
}
</style>
